<template>
  <div class="replace">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow title="更换手机号" @click-left="onClickLeft" />
    <!-- 内容 -->
    <div class="page">
      <div class="kqb-list">
        <div class="kqb-list-item">
          <div class="kqb-list-item-label">绑定手机号</div>
          <div class="kqb-list-item-inner fc-999">{{personMobileNo}}</div>
        </div>
        <div class="kqb-list-item navigator-arrow" :data-uri="'/confirm'" @click="pageJump">
          <div class="kqb-list-item-label">更换手机号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'replace',
  data () {
    return {
      personMobileNo: ''
    }
  },
  created () {
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    // 页面跳转
    pageJump (e) {
      console.log(e)
      const thisObj = this
      let uri = e.target.dataset.uri
      let queryData = {}
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    save () {
      alert(JSON.stringify(this.postData))
    }
  }
}
</script>

<style lang="css" scoped>
.replace {
  height: 100%;
  background: #f8fbff;
}
.kqb-list {
  margin: 30px 0 0 0;
}
</style>
